module.exports = __webpack_public_path__ + "images/emoji/diamond_shape_with_a_dot_inside.1ce0d96f570fd7f702e5.png";